// import Icon from '@ant-design/icons';
import React, { useState, useEffect } from "react";
import liracrypt from "../Liracrypt/liracrypt";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
import { Button, Col, Form, Input, Modal, Row, Select, Spin, Tooltip, message } from "antd";
import SessionError from "../ApiErrorComp/SessionError";
import noImg from '../../assets/static/noImg.jpeg'
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import {
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  LoadingOutlined,
  SolutionOutlined,
  MobileOutlined,
  ControlOutlined,
  FileJpgOutlined,
  DownloadOutlined,
  AuditOutlined,
  ProfileOutlined,
  FileDoneOutlined,
  UpSquareOutlined,
  DownSquareOutlined,
  PieChartOutlined,
  BarChartOutlined,
  ApartmentOutlined,
  EllipsisOutlined,
  HolderOutlined,
  MenuOutlined,
  RightSquareOutlined,
  LeftSquareOutlined,
  MenuUnfoldOutlined,
  BarcodeOutlined
} from "@ant-design/icons";
import HModal from "../../pages/HModal";
import ImageViewer from "../ImgViewer";
import ZenTablePrime from "../PhantomZen/ZenTablePrime";
import RoutePage from "../RoutePage";
import ZenJSONInput from "../PhantomZen/ZenJSONInput";
import ZenChartsInput from "../../pages/InputCreater/ZenChartsInput";
import DynamicZenChart from "../../pages/DynamicZenChart";
import ZenModal from "../ZenModal";
import { createRoute } from "../../utils/CustomFunc";
import queryString from "query-string";

const StablePrime = ({
  setSummary,
  url,
  data = {},
  identity,
  method,
  editFunction,
  deleteFunction,
  approveFunction,
  viewFunction,
  dynamicFunction,
  fourMFunction,
  autoUpdate,
  updateStable,
  showNoData,
  tableData,
  setPageHeader,
  pageTitle = 'Stable Prime',
  widthClass = ''
}) => {
  const [filterForm] = Form.useForm();
  const { search } = useLocation();
  const searchParams = queryString.parse(search);
  const [filterModal, setFilterModal] = useState({
    open: false,
    modalData: null
  })
  const urlCode = useSelector(state => state.urlCode);
  const [modal, setModal] = useState({
    // type: props.config.zenModal.typ,
    type: "",
    data: undefined,
    show: false,
    loading: false,
  });
  const [zenModal, setZenModal] = useState();

  const icons = {
    EllipsisOutlined,
    HolderOutlined,
    MenuOutlined,
    EditOutlined,
    DeleteOutlined,
    EyeOutlined,
    LoadingOutlined,
    SolutionOutlined,
    MobileOutlined,
    ControlOutlined,
    FileJpgOutlined,
    DownloadOutlined,
    AuditOutlined,
    ProfileOutlined,
    FileDoneOutlined,
    UpSquareOutlined,
    DownSquareOutlined,
    PieChartOutlined,
    BarChartOutlined,
    ApartmentOutlined,
    RightSquareOutlined,
    LeftSquareOutlined,
    MenuUnfoldOutlined,
    BarcodeOutlined
  }
  const [tblConfig, setTblConfig] = useState(null);
  const [fullTblData, setFullTblData] = useState();
  const [loading, setLoading] = useState(true);
  const [loopInterval, setloopInterval] = useState();
  const [loginError, setLoginError] = useState(false);
  const [loadData, setLoadData] = useState(null);
  // const loading = useSelector((state) => state.isReportLoading);

  const [activeColumn, setActiveColumn] = useState([]);

  const [action, setAction] = useState(null);

  const [show, setShow] = useState(showNoData || false);

  const [intervals, setIntervals] = useState(null);

  const [modalData, setModalData] = useState(null);

  const [modalMethod, setModalMethod] = useState("");

  const [modalVisible, setModalVisible] = useState(false);

  const [HRefresh, setHRefresh] = useState(true);

  const [routeModalData, setRouteModalData] = useState({
    show: false,
    data: null,
    type: '',
    title: '',
    urlData: null,
    width: '100%'
  });

  const [prefix, setPrefix] = useState(null);
  const [suffix, setSuffix] = useState(null);
  const [prefixDict, setPrefixDict] = useState({});
  const [suffixDict, setSuffixDict] = useState({});
  const [loop, setLoop] = useState();
  const [modalAction, setModalAction] = useState(null);
  const [imgViewer, setimgViewer] = useState({
    visible: false,
    img: null,
    title: '',
    loading: false
  })
  const [modTitle, setModTitle] = useState("");

  let pList = new Set();
  let sList = new Set();
  var inter;

  const dispatch = useDispatch();

  // function setLoading(state) {
  //   dispatch({
  //     type: "SET_REPORT_LOADING",
  //     payload: {
  //       loading: state,
  //     },
  //   });
  // }

  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

  const toggleModal = ({ show = false, data = undefined, type = '', loading = false }) => {
    setModal({ show, data, type, loading });
  }

  const zenPopupAction = (zenPopup, record) => {
    let urlData = { ...searchParams, ...data, ...zenPopup.params };
    if (zenPopup?.props) {
      urlData[zenPopup?.props] = record[zenPopup?.props];
    };
    if (zenPopup?.multiProps) {
      zenPopup?.multiProps.forEach((prop) => {
        urlData[prop] = record[prop];
      });
    };
    if (!urlData._id) {
      urlData._id = record._id
    }
    if (zenPopup?.typ === 'smodal') {
      toggleModal({
        loading: false,
        show: true,
        data: {
          urlData
        },
        type: zenPopup?.typ
      });
      return;
    };
    if (zenPopup?.typ === 'popUpModal') {
      toggleModal({
        loading: false,
        show: true,
        data: {
          ...record,
          urlData
        },
        type: zenPopup?.typ
      });
      return;
    };
    if (zenPopup?.typ === 'route') {
      toggleModal({
        loading: false,
        show: true,
        data: {
          route: zenPopup?.route,
          urlData
        },
        type: zenPopup?.typ
      });
      return;
    }
    if (zenPopup?.api) {
      toggleModal({ show: true, loading: true, type: zenPopup?.typ });
      liracrypt.get(`${zenPopup?.api}`, urlData).then(response => {
        toggleModal({
          show: true,
          data: (zenPopup?.typ === 'image' && response?.data?.isSuccess === false) ? noImg : response?.data?.data,
          loading: false,
          type: zenPopup?.typ
        })
      });
      return;
    }
  }

  const onConfirmation = ({ popData, urlData = {}, resolve, reject }) => {
    if (popData.method === 'GET') {
      liracrypt.get(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          if (popData?.editDoc) {
            let data = [...tblConfig.data];
            let updateIndex = data.findIndex(x => x._id === response.data.data._id);
            data[updateIndex] = response.data.data
            setTblConfig({
              ...tblConfig,
              data
            })
            setFullTblData(data);
          }
          resolve();
        }).catch(err => {
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
    if (popData.method === 'POST') {
      liracrypt.post(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          if (popData?.editDoc) {
            let data = [...tblConfig.data];
            let updateIndex = data.findIndex(x => x._id === response.data.data._id);
            data[updateIndex] = response.data.data
            setTblConfig({
              ...tblConfig,
              data
            })
            setFullTblData(data);
          }
          resolve();
        }).catch(err => {
          console.log(err);
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
    if (popData.method === 'PATCH') {
      liracrypt.patch(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          if (popData?.editDoc) {
            let data = [...tblConfig.data];
            let updateIndex = data.findIndex(x => x._id === response.data.data._id);
            data[updateIndex] = response.data.data
            setTblConfig({
              ...tblConfig,
              data
            })
            setFullTblData(data);
          }
          resolve();
        }).catch(err => {
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
    if (popData.method === 'DELETE') {
      liracrypt.delete(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          if (popData?.editDoc) {
            onDeleteFinish(response.data.data._id);
            // let data = [...tblConfig.data];
            // let updateIndex = data.findIndex(x => x._id === response.data.data._id);
            // data[updateIndex] = response.data.data
            // setTblConfig({
            //   ...tblConfig,
            //   data
            // })
          }
          resolve();
        }).catch(err => {
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
  }

  const onColumnClick = (record, actionBtn) => {
    let zenPopDataIndex = actionBtn;
    setModalData(ReEditRecord(record));
    setZenModal(zenPopDataIndex);
    if (zenPopDataIndex?.typ === 'download') {
      return downloadDoc(zenPopDataIndex, record)
    }
    if (zenPopDataIndex?.typ === 'newTab') {
      let zenParams = { ...searchParams, ...data, ...zenPopDataIndex.params };
      if (zenPopDataIndex?.api) {
        zenParams.api = zenPopDataIndex?.api;
      }
      let route = createRoute({
        props: zenPopDataIndex?.props,
        record,
        multiProps: zenPopDataIndex?.multiProps,
        params: { ...zenParams },
        urlCode,
        route: zenPopDataIndex?.urlType === 'dynamic' ? record[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
      });
      window.open(route, '_blank')
      return;
    };

    if (zenPopDataIndex?.typ === 'confirmationPopUp') {
      let urlData = { ...searchParams, ...data, ...zenPopDataIndex?.onOk?.params };
      if (zenPopDataIndex?.onOk?.multiProps) {
        zenPopDataIndex?.onOk?.multiProps.forEach((prop) => {
          urlData[prop] = record[prop];
        });
      };
      if (zenPopDataIndex?.onOk?.props) {
        urlData[zenPopDataIndex?.onOk?.props] = record[zenPopDataIndex?.onOk?.props];
      }

      Modal.confirm({
        title: zenPopDataIndex?.text,
        okText: zenPopDataIndex?.okButtonText,
        cancelText: zenPopDataIndex?.cancelButtonText,
        onOk: () => {
          return new Promise((resolve, reject) => {
            onConfirmation({
              popData: zenPopDataIndex?.onOk,
              resolve,
              reject,
              urlData
            });
          }).catch(() => console.log('Oops errors!'));
        }
      });
      return;
    }
    zenPopupAction(zenPopDataIndex, record)
  }


  const preData = (resData) => {

    if (resData.config.rowAction) {
      setActiveColumn(resData.config.rowAction);
    }
    if (resData.config.action) {
      setAction(resData.config.action);
    }

    setModTitle(resData.action);

    if (resData) {
      setLoadData(true);
    }

    resData.config.column.forEach((data) => {
      if (data.hasOwnProperty("prefix")) {
        pList.add(data["data_index"]);
        setPrefixDict({
          ...prefixDict,
          [data["data_index"]]: data["prefix"],
        });
      }
      if (data.hasOwnProperty("suffix")) {
        sList.add(data["data_index"]);
        setSuffixDict({
          ...suffixDict,
          [data["data_index"]]: data["suffix"],
        });
      }
    });
    setPrefix(pList);
    setSuffix(sList);

    setLoading(false);

    setTblConfig(resData);
    setFullTblData(resData.data);

    // ApiErrorComp(503);

  }


  const filterTblData = (values) => {
    let tblData = [...fullTblData];
    let { data_index, action, value, key } = values;
    if (action === 'equals') {
      tblData = tblData.filter(x => x[data_index]?.toString()?.toLowerCase() === value?.toLowerCase())
    }
    if (action === 'not_equals') {
      tblData = tblData.filter(x => x[data_index] !== value)
    }
    if (action === 'contains') {
      tblData = tblData.filter(x => x[data_index]?.toString()?.toLowerCase().includes(value?.toLowerCase()))
    }
    if (action === 'not_contains') {
      tblData = tblData.filter(x => !x[data_index]?.toString()?.toLowerCase().includes(value?.toLowerCase()))
    }
    setTblConfig({
      ...tblConfig,
      data: tblData
    });
    filterForm.resetFields();
    setFilterModal({
      open: false,
      modalData: null
    });
    document.getElementsByClassName(`active-stable-title`)[0]?.classList.remove('active-stable-title');
    document.getElementsByClassName(`stable-title-${key}`)[0].parentElement.classList.add('active-stable-title');
  }

  const fetchTblConfigData = ({ showLoading, extraData, cb }) => {
    if (!intervals && !showLoading) {
      setLoading(true);
    };

    if (method === "POST") {
      let formData = new FormData();
      let __data = { ...searchParams, ...data, ...extraData };
      Object.keys(__data).forEach((key) => {
        if (__data[key] !== null && __data[key] !== undefined) {
          formData.append(key, __data[key]);
        }
      });
      liracrypt
        .uploadFile(url, formData)
        .then((res, req) => {
          if (res.status === 204) {
            if (showNoData) {
              setShow(true);
            }
          }
          document.getElementsByClassName(`active-stable-title`)[0]?.classList.remove('active-stable-title');
          if (res.data.config.tableConfig.interval) {
            setIntervals(res.data.config.tableConfig.interval);
          }

          // if (!intervals) {
          // setIntervals(
          //   res.data.config.tableConfig.interval
          //     ? res.data.config.tableConfig.interval
          //     : 10000000
          // );

          if (res.data.config.rowAction) {
            setActiveColumn(res.data.config.rowAction);
          }
          if (res.data.config.action) {
            setAction(res.data.config.action);
          }

          if (res.data) {
            setLoadData(true);
          }

          setModTitle(res.data.config.modalHeader);



          res.data.config.column.forEach((data) => {
            if (data.hasOwnProperty("prefix")) {
              pList.add(data["data_index"]);
              setPrefixDict({
                ...prefixDict,
                [data["data_index"]]: data["prefix"],
              });
            }
            if (data.hasOwnProperty("suffix")) {
              sList.add(data["data_index"]);
              setSuffixDict({
                ...suffixDict,
                [data["data_index"]]: data["suffix"],
              });
            }
          });
          setPrefix(pList);
          setSuffix(sList);

          setLoading(false);


          setTblConfig(res.data);
          setFullTblData(res.data.data);
          if (cb) {
            cb();
          }

          // ApiErrorComp(503);
        })
        .catch(function (error) {
          setLoading(false);
          if (error.response !== undefined) {
            if (error.response.status !== 401) {
              ApiErrorComp(error.response.status);
            } else {
              setLoginError(true);
            }
          }
        });
    } else {
      let __data = { ...searchParams, ...data, ...extraData };
      liracrypt
        .get(url, __data)
        .then((res, req) => {
          if (res.status === 204) {
            if (showNoData) {
              setShow(true);
            }
          }
          if (setPageHeader) {
            setPageHeader(res.data.config.pageTitle || pageTitle)
          }
          document.getElementsByClassName(`active-stable-title`)[0]?.classList.remove('active-stable-title');
          if (setSummary) {
            setSummary(res.data.data1);
          }
          // if (!intervals) {
          if (res.data.config.tableConfig.interval) {
            setIntervals(res.data.config.tableConfig.interval);
          }
          // setIntervals(
          //   res.data.config.tableConfig.interval
          //     ? res.data.config.tableConfig.interval
          //     : 10000000
          // );

          if (res.data.config.rowAction) {
            setActiveColumn(res.data.config.rowAction);
          }
          if (res.data.config.action) {
            setAction(res.data.config.action);
          }

          setModTitle(res.data.action);

          if (res.data) {
            setLoadData(true);
          }
          res.data.config.column.forEach((data) => {
            if (data.visible !== false) {
              let label = data.title;
              data.label = label;
              data.title = (
                <Tooltip title={data.desc || label}>
                  <span onClick={() => {
                    // setFilterModal({
                    //   open: true,
                    //   modalData: { ...data }
                    // });
                    // filterForm.setFieldValue('key', label);
                    // filterForm.setFieldValue('data_index', data.data_index);
                  }
                  } className="ant-table-custom-title">{label}</span>
                </Tooltip>
              )
              if (data.hasOwnProperty("prefix")) {
                pList.add(data["data_index"]);
                setPrefixDict({
                  ...prefixDict,
                  [data["data_index"]]: data["prefix"],
                });
              }
              if (data.hasOwnProperty("suffix")) {
                sList.add(data["data_index"]);
                setSuffixDict({
                  ...suffixDict,
                  [data["data_index"]]: data["suffix"],
                });
              }
            } else {
              res.data.config.column = res.data.config.column.filter(x => x.data_index !== data.data_index)
            }

          });
          setPrefix(pList);
          setSuffix(sList);

          setTblConfig(res.data);
          setFullTblData(res.data.data);

          setLoading(false);
          if (cb) {
            cb();
          }

          // ApiErrorComp(503);
        })
        .catch(function (error) {
          // setLoading(false);
          if (error?.response !== undefined) {
            if (error.response.status !== 401) {
              ApiErrorComp(error.response.status);
            } else {
              setLoginError(true);
            }
          } else {
            ApiErrorComp();
          }
        });
    }
  };

  useEffect(() => {
    if (tableData) {

      preData(tableData)
    }
  }, []);


  useEffect(() => {
    if (modalVisible) {
      clearInterval(loopInterval);
    } else {
      if (url) {
        if (intervals) {
          let _loopInterval;
          _loopInterval = setInterval(() => {
            fetchTblConfigData({});
          }, intervals);
          setloopInterval(_loopInterval);
        }
      };
    }
  }, [modalVisible, intervals]);

  useEffect(() => {
    return () => {
      clearInterval(loopInterval)
    };
  }, [loopInterval])

  useEffect(() => {
    if (url) {
      fetchTblConfigData({});
    };
  }, [updateStable]);

  const ReEditRecord = (record) => {
    // Object.keys(record).forEach((key) => {
    //   if (prefix.has(key)) {

    //     record[key] = record[key].replace(prefixDict[key], "");
    //   }
    //   if (suffix.has(key)) {
    //     record[key] = record[key].replace(suffixDict[key], "");
    //   }
    // });
    record.tableDataIndex = tblConfig.data.findIndex(x => x._id === record._id);
    return record;
  };

  const onEditFinish = (args) => {
    if (!args?.data) {
      setModalVisible(false);
    };
    if (args?.data?.refreshStable) {
      setModalVisible(false);
      if (!document.getElementById('phantomPrimeSbmt')) {
        return fetchTblConfigData({ showLoading: true });
      };
      return document.getElementById('phantomPrimeSbmt').click();
    }
    let tblData = [...tblConfig?.data];
    let updatedData = { ...tblData[modalData.tableDataIndex] };
    Object.keys(args?.data).forEach(x => {
      updatedData[x] = args?.data[x];
    });
    tblData[modalData.tableDataIndex] = updatedData;
    setTblConfig({
      ...tblConfig,
      data: tblData
    });
    setFullTblData(tblData);
    if ((args?.loopToNextRow || tblConfig?.config?.action?.edit?.loopToNextRow) && ((modalData?.tableDataIndex + 1) < tblConfig.data.length)) {
      if (tblConfig?.config?.zenFuncs?.dynamicActionBtn) {
        onColumnClick(tblConfig.data[modalData.tableDataIndex + 1], zenModal);
      } else {
        setModalMethod("edit");
        setModalVisible(true);
        setModalData(ReEditRecord(tblConfig.data[modalData.tableDataIndex + 1]));
      }
    } else {
      setModalVisible(false);
      toggleModal({ show: false, data: null, type: '', loading: false });
    }
  };


  const ImgViewer = (
    <ImageViewer title={imgViewer.title} height={action?.popUpImage?.height} width={action?.popUpImage?.width} hideModal={() => setimgViewer({
      ...imgViewer,
      visible: false,
      title: '',
      loading: false
    })} visible={imgViewer.visible} imgUrl={imgViewer.img} loading={imgViewer.loading} />
  );

  const quickViewImage = (id, title) => {
    let cachedImg = localStorage.getItem(`cache_img_${id}`);
    if (cachedImg) {
      setimgViewer({
        visible: true,
        title,
        img: cachedImg
      })
    } else {
      setimgViewer({
        visible: true,
        title,
        loading: true
      });
      liracrypt.get(`/imagecontrol`, { _id: id }).then(response => {
        if (response.data.isSuccess) {
          localStorage.setItem(`cache_img_${id}`, response.data.data);
          setimgViewer({
            visible: true,
            title,
            img: response.data.data
          });
        } else {
        }
      })
        .catch(err => {
          console.log(err);
        })
    }

  };

  const downloadDoc = (btn = {}, record) => {
    let urlData = { ...searchParams, ...data, ...btn?.params };
    if (btn?.multiProps) {
      btn?.multiProps.forEach((prop) => {
        urlData[prop] = record[prop];
      });
    };
    if (btn?.props) {
      urlData[btn?.props] = record[btn?.props];
    }
    urlData.token = localStorage.getItem("token");
    urlData.urlCode = urlCode;
    let _searchParams = new URLSearchParams(urlData);
    document.getElementById('downloadLink').setAttribute("href", `${process.env.REACT_APP_API_ENDPOINT}${btn?.api}?${_searchParams}`);
    document.getElementById('downloadLink').click();
  }

  const IconComponent = (props) => {
    const Icon = props.icon;
    return Icon ? <Icon {...props} /> : <></>
  }

  const onDeleteFinish = (id) => {
    let _id = id || modalData?._id;
    setTblConfig(prev => {
      const filteredData = prev.data.filter(x => x._id !== _id);
      setFullTblData(filteredData);
      return {
        ...prev,
        data: filteredData
      };
    });
  }
  const dynamicActionBtns = (text, record) => {
    return (
      activeColumn?.length ? (
        <div style={{ display: 'inline-flex', justifyContent: 'flex-start', width: '100%', flexWrap: 'wrap' }}>
          {
            activeColumn.map((x, i) => (
              !record[`hide_${x}`] ?
                <div key={`dynamic-action-btn-${i}`}>
                  <Tooltip placement="bottom" title={action[x]?.toolTip || 'Action'}>
                    <IconComponent
                      icon={icons[x]}
                      onClick={() => onColumnClick(record, action[x])}
                      style={action[x]?.iconStyle}
                    />
                  </Tooltip>
                </div> : <></>
            ))
          }
        </div>
      ) : <></>
    )

  }

  const EditModal = (text, record) => {
    return (
      <div style={{ display: 'inline-flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>

        {activeColumn ? (
          <>
            <div style={{ paddingTop: "5px", paddingBottom: "5px" }}>
              {(activeColumn.includes("route") && !record?.hide_route) ? (
                <Tooltip placement="bottom" title={action?.route?.toolTip || 'Route'}>
                  <IconComponent
                    icon={icons[action?.route?.icon]}
                    onClick={
                      viewFunction
                        ? () => {
                          viewFunction(record)
                        }
                        : () => {
                          let urlData = { ...searchParams, ...data, ...action.route.params };
                          if (action.route?.multiProps) {
                            action.route?.multiProps.forEach((prop) => {
                              urlData[prop] = record[prop];
                            });
                          };
                          if (action.route?.props) {
                            urlData[action.route?.props] = record[action.route?.props];
                          };
                          setRouteModalData({
                            show: true,
                            route: action.route.route,
                            urlData: urlData,
                            title: action.route.pageTitle || 'Route Modal XYZ AAA',
                            type: 'route',
                            width: action.route.width || '100%'
                          })
                        }
                    }
                    style={action.route.iconStyle}
                  />
                </Tooltip>
              ) : (
                <></>
              )}
              {(activeColumn.includes("edit") && !record?.hide_edit) ? (
                <Tooltip placement="bottom" title={action?.edit?.toolTip || 'Edit'}>
                  <IconComponent
                    icon={icons[action.edit.icon]}
                    style={action.edit.iconStyle}
                    onClick={
                      editFunction
                        ? editFunction(record)
                        : () => {
                          setModalAction(action.edit)
                          setModalMethod("edit");
                          setModalVisible(true);
                          setModalData(ReEditRecord(record));
                        }
                    }
                  />{" "}
                </Tooltip>
              ) : (
                <></>
              )}

              {(activeColumn.includes("approve") && !record?.hide_approve) ? (
                <Tooltip placement="bottom" title={action?.approve?.toolTip || 'Approve'}>
                  <IconComponent
                    icon={icons[action?.approve?.icon]}
                    onClick={
                      approveFunction
                        ? approveFunction(record)
                        : () => {
                          setModalAction(action.approve)
                          setModalMethod("approve");
                          setModalVisible(true);
                          setModalData(ReEditRecord(record));
                        }
                    }
                    style={action.approve.iconStyle}
                  />
                </Tooltip>
              ) : (
                <></>
              )}

              {(activeColumn.includes("dynamicModal") && !record?.hide_dynamicModal) ? (
                <Tooltip placement="bottom" title={action?.dynamicModal?.toolTip || 'Dynamic Modal'}>
                  <IconComponent
                    icon={icons[action?.dynamicModal?.icon]}
                    onClick={
                      dynamicFunction
                        ? dynamicFunction(record)
                        : () => {
                          setModalAction(action.dynamicModal)
                          setModalMethod("dynamicModal");
                          setModalVisible(true);
                          setModalData(ReEditRecord(record));
                        }
                    }
                    style={action.dynamicModal.iconStyle}
                  />
                </Tooltip>
              ) : (
                <></>
              )}
              {(activeColumn.includes("delete") && !record?.hide_delete) ? (
                <Tooltip placement="bottom" title={action?.delete?.toolTip || 'Delete'}>
                  <IconComponent
                    icon={icons[action.delete.icon]}
                    onClick={
                      deleteFunction
                        ? deleteFunction(record)
                        : () => {
                          setModalAction(action.delete)
                          setModalMethod("delete");
                          setModalVisible(true);
                          setModalData(ReEditRecord(record));
                        }
                    }
                    style={action.delete.iconStyle}
                  />
                </Tooltip>
              ) : (
                <></>
              )}
              {(activeColumn.includes("popUpImage") && !record?.hide_popUpImage) ? (
                <Tooltip placement="bottom" title={action?.popUpImage?.toolTip || 'PopupImage'}>
                  <IconComponent
                    icon={icons[action.popUpImage.icon]}
                    onClick={() => quickViewImage(record.popUpImgidActnBtn, action?.popUpImage?.pageTitle)}
                    style={action.popUpImage.iconStyle}
                  />
                </Tooltip>
              ) : (
                <></>
              )}
              {activeColumn.includes("download") && record?.enableDownload ? (
                <Tooltip placement="bottom" title={action?.download?.toolTip || 'Download'}>
                  <IconComponent
                    icon={icons[action?.download?.icon]}
                    onClick={
                      approveFunction
                        ? approveFunction(record)
                        : () => downloadDoc(action?.download, record)}
                    style={action.download.iconStyle}
                  />
                </Tooltip>
              ) : (
                <></>
              )}
              {(activeColumn.includes("fourM") && !record?.hide_fourM) ? (
                <Tooltip placement="bottom" title={action?.fourM?.toolTip || 'FourM'}>
                  <IconComponent
                    icon={icons[action.fourM.icon]}
                    onClick={
                      fourMFunction
                        ? fourMFunction(record)
                        : () => {
                          setModalAction(action.fourM)
                          setModalMethod("fourM");
                          setModalVisible(true);
                          setModalData(ReEditRecord(record));
                        }
                    }
                    style={action.fourM.iconStyle}
                  />
                </Tooltip>
              ) : (
                <></>
              )}
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    );
  };

  const editColumnData = [
    {
      _id: 'action',
      title: tblConfig?.config?.tableConfig?.ratHeader || "Action",
      data_index: 'action',
      width: "220px",
      render: (text, record) => tblConfig?.config?.zenFuncs?.dynamicActionBtn ? dynamicActionBtns(text, record) : EditModal(text, record),
    },
  ];

  const EModal = (
    <>
      {modalData && action[modalMethod] && modalMethod ? (
        <HModal
          extraData={{ ...data }}
          modalAction={modalAction}
          onEditFinish={onEditFinish}
          onDeleteFinish={onDeleteFinish}
          modalData={modalData}
          isModalVisible={modalVisible}
          setIsModalVisible={(val) => { setModalVisible(val); setModalData(null) }}
          action={action}
          modalMethod={modalMethod}
          preventSubmitBtnClick={true}
        // fetch={fetchTblConfigData}
        />
      ) : (
        <></>
      )}
    </>
  );
  return (
    <>
      <SessionError visible={loginError} />
      {EModal}
      <Modal open={filterModal.open} onCancel={() => {
        setFilterModal({
          open: false,
          modalData: null
        });
        filterForm.resetFields();
      }} title={"Filter Data"} okButtonProps={{ hidden: true }} cancelButtonProps={{ hidden: true }}>
        <div
          className="AuditSection CreateAudit"
          style={{
            padding: "10px",
            maxHeight: "800px",
            overflowY: "scroll",
            overflowX: "hidden",
          }}
        >
          <div className="ThemeForm">
            <Form
              labelWrap={true}
              name={"filterForm"}
              form={filterForm}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              layout="horizontal"
              colon={false}
              onFinish={filterTblData}
              size="large"
            >
              <Form.Item name={"key"} label={"Key"}>
                <Input />
              </Form.Item>
              <Form.Item name="data_index" hidden />
              <Form.Item name={"action"} label={"Action"}>
                <Select
                  options={[
                    { label: 'Equals', value: 'equals' },
                    { label: 'Not Equals', value: 'not_equals' },
                    { label: 'Contains', value: 'contains' },
                    { label: 'Not Contains', value: 'not_contains' }
                  ]}
                />
              </Form.Item>
              <Form.Item name={"value"} label={"Value"}>
                <Input />
              </Form.Item>
              <Form.Item name={"sort"} label={"Sort"}>
                <Select
                  options={[
                    { label: '--', value: '' },
                    { label: 'Ascending', value: 'ascending' },
                    { label: 'Descending', value: 'descending' }
                  ]}
                />
              </Form.Item>
              <Row justify={"center"}>
                <Col span="10" style={{ display: 'inline-flex' }}>
                  <Button htmlType="submit" type="primary">Submit</Button>
                  <Button style={{ marginLeft: 10 }} onClick={() => {
                    setTblConfig({
                      ...tblConfig,
                      data: fullTblData
                    });
                    setFilterModal({
                      open: false,
                      modalData: null
                    });
                    document.getElementsByClassName(`active-stable-title`)[0]?.classList.remove('active-stable-title');
                  }} htmlType="button" type="primary" danger>Reset Filters</Button>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </Modal>
      {ImgViewer}
      {
        (tblConfig?.config?.zenFuncs?.chartElement && tblConfig?.config?.chartElement) ?
          <div style={{ width: '100%', marginTop: 30, display: 'flex', justifyContent: 'center' }}>
            <div style={{ maxWidth: tblConfig?.config?.tableConfig?.tableWidth, width: '100%' }}>
              <DynamicZenChart
                chartData={tblConfig?.config?.chartElement}
              />
            </div>

          </div>
          // <Row style={{ width: '100%', marginTop: 30 }}>
          //   {
          //     tblConfig?.config?.chartData.map((chart, i) => (
          //       <React.Fragment key={`stable-chart-${i}`}>
          //         <ZenChartsInput
          //           chartData={chart.chartData}
          //           divId={`stable-${chart.typ}-${i}`}
          //           typ={chart.typ}
          //           colSpan={chart.colSize}
          //           style={chart.style}
          //         />
          //       </React.Fragment>
          //     ))
          //   }
          // </Row> 
          : <></>
      }
      <Row>
        {
          (tblConfig?.config?.zenFuncs?.headerRoute && tblConfig?.config?.headerRoute?.route) ?

            <Col span={24}>
              <div style={{ width: tblConfig?.config?.headerRoute?.width || '100%', display: 'block', margin: 'auto' }}>
                <RoutePage route={tblConfig?.config?.headerRoute?.route} params={{ ...searchParams, ...data, ...tblConfig?.config?.headerRoute?.params }} />
              </div>
            </Col> : <></>
        }
        <Col span={24}>
          <div
            className="container-fluid ">
            <div
              className={widthClass}
              style={{
                // boxShadow: "0px 0px 10px 0px lightgrey",
                borderRadius: "15px",
                // overflow: "hidden",
              }}
            >
              {
                loading ?
                  <div
                    style={{
                      display: "flex",
                      height: '20vh',
                      flex: 1,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Spin indicator={antIcon} />
                  </div> :
                  tblConfig && activeColumn ? (
                    <div style={{ minHeight: !tblConfig.config.column.length ? '50vh' : 'auto', display: 'flex', justifyContent: 'center' }}>
                      <ZenModal modal={modal} toggleModal={toggleModal} zenModal={zenModal} smodalCallback={onEditFinish} />
                      <ZenTablePrime
                        fetchTblConfigData={fetchTblConfigData}
                        formData={{ ...data }}
                        widthClass={widthClass}
                        routeModalData={routeModalData}
                        toggleRouteModal={() => setRouteModalData({
                          show: false,
                          route: '',
                          urlData: null,
                          title: '',
                          type: '',
                          width: '100%'
                        })}
                        tblConfig={tblConfig}
                        setTblConfig={setTblConfig}
                        editColumn={activeColumn.length !== 0 ? editColumnData : []}
                      />

                    </div>
                  ) : (
                    <>
                      <div
                        className="tableBackground"
                        style={{
                          textAlign: "center",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          borderRadius: "20px",
                        }}
                      >
                        <>
                          {show ? (
                            <>
                              <div
                                style={{
                                  backgroundColor: "#000f17",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <div>
                                  <h3 style={{ color: "#bdc3c7", margin: 0 }}>
                                    {/* No {identity} Data found during this period ! */}
                                    No Data found !
                                  </h3>
                                </div>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      </div>
                    </>
                  )}
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default StablePrime;
